let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bu2ao")).then(() => parcelRequire('1L7Vq'));